import merge from 'lodash.merge';
import { createMuiTheme, createTheme, Theme } from '@material-ui/core/styles';
import {
    GasDefaultPalette,
    GivelifyColorPalette,
} from '@givelify/givelify-ui';
import { PaperThemeOverrides, PaperThemeProps } from './components/paper';
import { typography, typographyOverrides } from './components/typography';
import { inputTheme } from './components/inputTheme';
import { buttonTheme } from './components/buttonTheme';
import { linkTheme } from './components/linkTheme';
import { selectTheme } from './components/select';
import { spacing } from './components/spacing';

export const lightGray = '#D8D8D8';

const theme = createTheme({
    colors: GivelifyColorPalette,
    gas: GasDefaultPalette,
    palette: {
        primary: {
            dark: '#5F48F0',
            main: '#715AFF',
            light: '#3591c8',
        },
        secondary: {
            dark: '#077aaa',
            main: '#715AFF',
            light: '#3bbff6',
        },
        background: {
            default: '#FFFFFF',
            paper: '#FFFFFF',
        },
        text: {
            primary: '#73717F',
        },
    },

    overrides: {
        ...PaperThemeOverrides,
        ...typographyOverrides,
        MuiCard: {
            root: {
                borderRadius: 11,
                border: '1px solid #CACACA',
            },
        },
        MuiLink: {
            root: {
                cursor: 'pointer',
            },
        },
    },

    props: {
        ...PaperThemeProps,
        MuiCard: {
            elevation: 0,
        },
    },

    typography,
    spacing,
});

// changing elevation
const shadows = theme.shadows;
shadows[1] = '0px 0px 15px 0px rgba(0,0,0,0.1)';

export const regularModeTheme = createMuiTheme({
    colors: GivelifyColorPalette,
    gas: GasDefaultPalette,
    palette: {
        primary: theme.palette.primary,
        secondary: theme.palette.secondary,
        background: {
            paper: theme.palette.background.paper,
        },
    },
});

const mergeTheme: Theme = {
    ...theme,
    ...merge(
        inputTheme(theme),
        buttonTheme(theme),
        linkTheme(theme),
        selectTheme(theme) as Theme,
    ),
    shadows,
};

export default mergeTheme;
